module.exports = __webpack_public_path__ + "img/no-credit-card.aaefbe23.svg";